import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCustomControl } from "../contexts";
import "../style/controls/headline.scss";
const Headline = ()=>{
    const { params: { label, description, level } } = useCustomControl();
    const HLevel = `h${level}`;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(HLevel, {
                children: label
            }),
            !!description && /*#__PURE__*/ _jsx("span", {
                className: "description customize-control-description",
                dangerouslySetInnerHTML: {
                    __html: description
                }
            })
        ]
    });
};
export { Headline };
